
export enum PredefinedAchievementCheckpoint {
        
        MINIBAR_INVITE_CLICK = "minibar-inivite-click",

        MINIBAR_INVITE_COPY = "minibar-inivite-copy",
        
        MINIBAR_DASHBOARD_CLICK = "minibar-dashboard-click",

        MONACO_RUN_CLICK = "monaco-run-click",

        MONACO_LANGUAGES_CLICK = "monaco-languages-click",

        TEAMS_ONBOARDED_PERSONAL = "teams-tenant-personal",

        TEAMS_ONBOARDED_GROUP = "teams-tenant-group",

        TEAMS_ONBOARDED_CHANNEL = "teams-tenant-channel",

        TEAMS_ONBOARDED_TEAM = "teams-tenant-team",

        TEAMS_NEW_CLICK = "teams-new-click",

        TEAMS_JOIN_CLICK = "teams-join-click",

        TEAMS_SAVE_CLICK = "teams-save-click",

        MEET_PARTICIPANT_JOINED= "meet-participant-joined",

        MEET_ENDED_EXPLICIT = "meet-ended-explicit",
        
        MEET_ENDED_IMPLICIT = "meet-ended-implicit",

        MEET_FEEDBACK_SHOWN = "meet-feedback-shown",

        MEET_FEEDBACK_RATE = "meet-feedback-rate",

        MEET_FEEDBACK_TEXT = "meet-feedback-text",

}
        